import React, { useEffect, useState, ReactNode } from 'react'
import { useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { getGustoSession, getGustoLastLogin, getGustoLastSync, getGustoImportedStep, getGustoStepsCompleted } from '../../store/settings/selectors'
import { URLS } from '../../resources/constants';
import moment from 'moment';
import { gustoApi } from '../../resources/hooks/api/gustoApiHook';
import { getBranch } from '../../store/user/selectors'
import DatePickerModal from '../../components/Modal/DatePickerModal/DatePickerModal';
import toast from 'react-hot-toast';

const GustoSteps = [{
    label: 'Integration Settings (Chart of Accounts Mapping)',
    value: 1
}, {
    label: 'Payroll Journal Import Request',
    value: 2
}/*, {
    label: 'Scheduled Automation Settings',
    value: 3
}*/];

interface Props { }

const Dashboard: React.FC<Props> = () => {

    const navigate = useNavigate();

    const gustoSession = useSelector(getGustoSession);
    const gustoLastLogin = useSelector(getGustoLastLogin);
    const gustoLastSync = useSelector(getGustoLastSync);
    const gustoStepCompleted = useSelector(getGustoStepsCompleted);
    const gustoImportedStep = useSelector(getGustoImportedStep);

    const branchData = useSelector(getBranch);

    const { gustoImportData } = gustoApi();

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isOpenDateModal, setIsOpenDateModal] = useState<boolean>(false);
    const [selectedDate, setSelectedDate] = useState<Date[]>([]);

    useEffect(() => {
        if (gustoSession) {
            navigate(URLS.GUSTO_CONNECTION)
        }
    }, [])

    const _handleGustoImportData = (step: number) => {
        if (step == 1 && gustoImportedStep == 1) {
            navigate(URLS.GUSTO_CHART_OF_ACCOUNT)
            return;
        }
        if (step == 2 && gustoImportedStep == 2) {
            navigate(URLS.GUSTO_PAYROLL_JOURNAL_LIST)
            return;
        }
        /*if ( step > 1 ) {
            toast.error('This feature is not available yet.');
            return;
        }*/
        // if (step == 2 && gustoImportedStep == 2) {
        //     navigate(URLS.QUICKBOOK_BB)
        //     return;
        // }
        /*if (step == 3 && gustoImportedStep == 3) {
            navigate(URLS.QUICKBOOK_BS_PL)
            return;
        }*/
        if ((step == 2) && !selectedDate.length) {
            setIsOpenDateModal(true);
            return;
        }


        const params: any = {};
        params['branch_id'] = +branchData['id'];
        params['step'] = step;

        /*if (step == 2) {
            params['bs_import_start_date'] = moment(selectedDateBB[0]).startOf('month').format('YYYY-MM-DD');
            params['bs_import_end_date'] = moment(selectedDateBB[0]).endOf('month').format('YYYY-MM-DD');
        } else if (step == 3) {
            params['bs_import_start_date'] = moment(selectedDateBB[0]).startOf('month').format('YYYY-MM-DD');
            params['bs_import_end_date'] = moment(selectedDateBB[1]).format('YYYY-MM-DD');
        } else if (step > 3) {
            toast.error('This feature is not available yet.');
            return;
        }*/

        if (step == 2) {
            params['month'] = +moment(selectedDate[0]).startOf('month').format('MM');
            params['year'] = +moment(selectedDate[0]).startOf('month').format('YYYY');
        } else if (step > 2) {
            toast.error('This feature is not available yet.');
            return;
        }

        setIsLoading(true)
        gustoImportData(params, (message: string, resp: any) => {
            setIsLoading(false);
            setSelectedDate([])
            toast.success(message);
            if (step == 1) {
                navigate(URLS.GUSTO_CHART_OF_ACCOUNT)
            } else if (step == 2) {
                navigate(URLS.GUSTO_PAYROLL_JOURNAL_LIST)
            }/* else if (step == 3) {
                navigate(URLS.QUICKBOOK_BS_PL)
            }*/

        }, (message: string, resp: any) => {
            setIsLoading(false)
            setSelectedDate([])
            console.log(resp)
            toast.error(message)
        })
    }

    return (
        <div className="main-container flex-grow-1">
            <div className="container-fluid">
                <div className="page-title pb-4 pt-3" id="ux_page_title">
                    <div className="row align-items-center">
                        <div className="col-sm-12 align-items-center d-flex justify-content-between">
                            <h1 className="h3 font-weight-700 mb-0 d-inline-flex">
                                Payroll Integration
                            </h1>
                        </div>
                    </div>
                </div>

                <div className=" executive-dashboard">
                    <div className="dashboard-top-part">
                        <div className='d-flex gap-1'>
                            <div className='border-end d-flex flex-column gap-3 pe-5 w-50'>
                                <h6>You are connected with Gusto</h6>
                                <div className='d-flex gap-4'>
                                    <div className='border' style={{ borderRadius: '5px' }}>
                                        <div className='align-items-center d-flex justify-content-center' style={{ backgroundColor: '#D9D9D9', borderTopRightRadius: '5px', borderTopLeftRadius: '5px' }}>
                                            <img src="gusto.svg" alt="" className='h-70' />
                                        </div>
                                        <div className='align-items-center d-flex gap-1 justify-content-center pb-1 pt-1'>
                                            <label>Connected</label>
                                        </div>
                                    </div>
                                    <div className='d-flex flex-column'>
                                        <span>Connected On: {gustoLastLogin ? moment(gustoLastLogin).format('Do MMM YYYY LT') : 'NA'}</span>
                                        <span>Last Sync: {gustoLastSync ? moment(gustoLastSync).format('Do MMM YYYY LT') : 'NA'}</span>
                                    </div>

                                </div>
                            </div>
                            <div className='ps-4 w-100'>
                                <h6>Setup Wizard</h6>
                                <div className='d-flex flex-column gap-2 p-4'>
                                    {GustoSteps.map((step, index) => {
                                        return (
                                            <div key={index} className='d-flex gap-2 align-items-center'>
                                                <input type="checkbox" id={`step-${index}`} checked={step.value <= +gustoStepCompleted} disabled />
                                                <label htmlFor={`step-${index}`} className='mb-0'>{step.label}</label>
                                            </div>
                                        )
                                    })}
                                </div>
                                <div className="row mt-md-5">
                                    <div className="col-md-12 d-flex justify-content-end">
                                        {
                                            +gustoStepCompleted >= 2 ? (
                                                <div>
                                                    <Link to={URLS.GUSTO_CHART_OF_ACCOUNT} className="btn btn-primary">
                                                        <img src="settings.png" alt="" /> &nbsp;
                                                        Integration Settings
                                                    </Link>&nbsp;
                                                    <Link to={URLS.GUSTO_PAYROLL_JOURNAL_LIST} className="btn btn-primary">
                                                        <img src="import.png" alt="" /> &nbsp;
                                                        Payroll Journal Import
                                                    </Link>
                                                </div>
                                            ) : (
                                                <Link to={"javascript:void(0)"} className="btn btn-primary" onClick={() => _handleGustoImportData(+gustoStepCompleted + 1)}>
                                                    {isLoading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : <span>Continue</span>}
                                                </Link>
                                            )
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                isOpenDateModal &&
                <DatePickerModal title={'Import Payroll Journal'} step={+gustoStepCompleted + 1} selectDate={setSelectedDate} handleBBDateSelection={() => _handleGustoImportData(+gustoStepCompleted + 1)} closeModal={() => setIsOpenDateModal(false)} />
            }
        </div>
    )
}

export default Dashboard
